import { render, staticRenderFns } from "./PointCardOrder.vue?vue&type=template&id=43191c41"
import script from "./PointCardOrder.vue?vue&type=script&lang=js"
export * from "./PointCardOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports